__turbopack_context__.v({
  "placeholder": "default-header-module-scss-module__3LhIsq__placeholder",
});
